import { render, staticRenderFns } from "./VirtualScreenCastPanel.vue?vue&type=template&id=2a7ea1e0&scoped=true"
import script from "./VirtualScreenCastPanel.vue?vue&type=script&lang=ts"
export * from "./VirtualScreenCastPanel.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScreenCastPanel.vue?vue&type=style&index=0&id=2a7ea1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ea1e0",
  null
  
)

export default component.exports